// import { IconCloud } from "@/registry/magicui/icon-cloud";

import { IconCloud } from "../../magicUi/IconCloud";

const slugs = [
  "typescript",
  "javascript",
// //   "dart",
  "java",//img not visible
  "react",
// //   "flutter",
//   "android",
  "html5",
  "css3",
// //   "nodedotjs",
// //   "express",
// //   "nextdotjs",
// //   "prisma",
  "amazonaws",//img not visible
  "postgresql",
// //   "firebase",
  "nginx",
// //   "vercel",
// //   "testinglibrary",
// //   "jest",
// //   "cypress",
  "docker",
  "git",
  "jira",
  "github",
  "gitlab",
  "visualstudiocode",//img not visible
// //   "androidstudio",
//   "sonarqube",
// //   "figma",
"python",
"springboot",
"angular",
"mysql",
"salesforce"

];

export function IconCloudDemo() {
  const images = slugs.map(
    (slug) => `https://cdn.simpleicons.org/${slug}/${slug}`,
  );

  return (
    <div className="relative flex size-full items-center justify-center overflow-hidden">
      <IconCloud images={images} />
    </div>
  );
}
